// extracted by mini-css-extract-plugin
module.exports = {"list_item_text_wrapper":"sidebar_list_item_text_wrapper__3GgpQ"};